module.exports = __webpack_public_path__ + "static/img/30007 (1).1f9a7f8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30007 (1).webp
// module id = 5fBJ
// module chunks = 14